import {
  Loading,
  Title,
  useGetList,
  useGetOne,
  useRedirect,
  useTranslate
} from 'react-admin'
import {
  Card,
  CardContent,
  Grid,
  Button,
  Typography,
  Theme,
  useMediaQuery
} from '@mui/material'
import { useState } from 'react'
import { find, isNil, map, split } from 'lodash/fp'
import { format, startOfMonth } from 'date-fns/fp'
import log from 'loglevel'

import { CardCreateOrEditDialog } from '../Credit'
import { PartnerInvoice } from '../../types'

log.setLevel(log.levels.DEBUG)

const cardExpireMinutes = 10

export const Dashboard: React.FC<{ id: string }> = ({ id }) => {
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'))
  const translate = useTranslate()
  const redirect = useRedirect()
  const [dialogOpen, setDialogOpen] = useState(false)
  const [sentSMS, setSentSMS] = useState(false)
  const { data: partner, isLoading } = useGetOne('partners', { id })
  const { data: invoices, isLoading: isLoadingInvoice } = useGetList(
    'invoices',
    {
      filter: {
        date: { eq: format('yyyy-MM-dd')(startOfMonth(Date.now())) }
      },
      pagination: { page: 1, perPage: 10000 },
      sort: { field: 'partner', order: 'DESC' }
    }
  )
  if (isLoading || isLoadingInvoice) return <Loading />
  log.debug({ id, partner })
  const cardRegister =
    isNil(partner.gmoCardSeq) || partner.gmoCardSeq === 'none'
  const contents = cardRegister ? (
    <>
      {map((item: string) => <Typography>{item}</Typography>)(
        split('\n')(translate('mine.credit.dialogs.registerSub'))
      )}
    </>
  ) : sentSMS ? (
    <>
      {map((item: string) => <Typography>{item}</Typography>)(
        split('\n')(translate('mine.credit.dialogs.sendSmsResult'))
      )}
    </>
  ) : (
    <>
      {' '}
      {map((item: string) => <Typography>{item}</Typography>)(
        split('\n')(translate('mine.credit.dialogs.sendSmsRequest'))
      )}
    </>
  )
  log.debug('[Dashboard]', { cardRegister })
  const edit = (): void => {
    redirect(`/partners/${id}`)
  }
  const credit = (): void => {
    setDialogOpen(true)
  }
  const criterions = (): void => {
    redirect(`/criterions/${id}`)
  }
  const invoice = (): void => {
    redirect(`/invoice/${id}`)
  }
  return (
    <>
      <Card>
        <Title title={translate('mine.title')} />
        <CardContent>
          <Grid container justifyContent="center">
            <Grid item xs={10} sx={{ marginTop: '5em' }}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                fullWidth
                disabled={
                  isNil(process.env['REACT_APP_NO_GMO']) &&
                  isNil(partner.gmoCardSeq)
                }
                onClick={edit}>
                {translate('mine.partners.edit')}
              </Button>
            </Grid>
            <Grid item xs={10} sx={{ marginTop: '2em' }}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                fullWidth
                disabled={
                  isNil(process.env['REACT_APP_NO_GMO']) &&
                  isNil(partner.gmoCardSeq)
                }
                onClick={criterions}>
                {translate('mine.users.criterions')}
              </Button>
            </Grid>
            {/* <Grid item xs={10} sx={{ marginTop: '2em' }}>
              <Button
                variant="contained"
                color="secondary"
                size="large"
                fullWidth
                onClick={houses}>
                {translate('mine.users.housees')}
              </Button>
            </Grid> */}
            <Grid item xs={10} sx={{ marginTop: '2em' }}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                fullWidth
                disabled={!isNil(process.env['REACT_APP_NO_GMO'])}
                onClick={credit}>
                {translate('mine.users.credit.l1')}
                {isDesktop ? '' : <br />}
                {translate('mine.users.credit.l2')}
              </Button>
            </Grid>
            {isNil(process.env['REACT_APP_NO_INVOICE']) && (
              <Grid item xs={10} sx={{ marginTop: '2em' }}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  fullWidth
                  disabled={
                    !isNil(process.env['REACT_APP_NO_GMO']) ||
                    partner.gmoCardSeq === 'none' ||
                    isNil(
                      find((item: PartnerInvoice) => item.partner === id)(
                        invoices
                      )
                    )
                  }
                  onClick={invoice}>
                  {translate('mine.users.invoice')}
                </Button>
              </Grid>
            )}
          </Grid>
        </CardContent>
      </Card>
      <CardCreateOrEditDialog
        setDialogOpen={setDialogOpen}
        id={id}
        dialogOpen={dialogOpen}
        cardRegister={cardRegister}
        expireMinutes={cardExpireMinutes}
        setSentSMS={setSentSMS}
        sentSMS={sentSMS}>
        {contents}
      </CardCreateOrEditDialog>
    </>
  )
}
